import { isAfter, startOfDay, startOfMonth } from 'date-fns';

export const dateIsBeforeAllowedDate = (
  fromDate: Date | undefined,
  fromMonth: Date | undefined,
  typedDate: Date,
) =>
  (fromDate && isAfter(startOfDay(fromDate), typedDate)) ||
  (fromMonth && isAfter(startOfMonth(fromMonth), typedDate));
